<i
  [matTooltip]="tooltipText"
  [matTooltipClass]="tooltipClass"
  [matTooltipPosition]="tooltipPosition"
  class="fal fa-info-circle"
></i>
